/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreatedTeamRequest } from '../models/CreatedTeamRequest';
import type { PatchedTargetRespondentRequest } from '../models/PatchedTargetRespondentRequest';
import type { PatchedTeamRequest } from '../models/PatchedTeamRequest';
import type { RosterSegments } from '../models/RosterSegments';
import type { TargetRespondent } from '../models/TargetRespondent';
import type { Team } from '../models/Team';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RosterClient {

    /**
     * Get roster team and segment names and values
     * @returns RosterSegments
     * @throws ApiError
     */
    public static getRosterSegments(): CancelablePromise<RosterSegments> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/roster/segments',
        });
    }

    /**
     * Get the possible targets for a survey.
     * @returns TargetRespondent
     * @throws ApiError
     */
    public static getStudyTargets({
        studyRef,
        contains,
        email,
        name,
        segment,
        slackSelected,
    }: {
        studyRef: string,
        /**
         * A case-insensitive, partial-match search of various text fields including name, email address, and Slack user name.
         */
        contains?: string,
        /**
         * A case-insensitive, partial-match search of email addresses.
         */
        email?: string,
        /**
         * A case-insensitive, partial-match search of names.
         */
        name?: string,
        /**
         * Filter results by specific segment names-value pairs. For example: ?segment=Location__Bermuda&segment=Shape__Triangle will return all results with segments matching both of those name-value pairs. Or ?segment=Location__Bermuda&segment=Location__Boston to support multi-select components by returning results matching either.
         */
        segment?: Array<string>,
        /**
         * Return only target respondents with slack users who have been selected for this study.
         */
        slackSelected?: boolean,
    }): CancelablePromise<Array<TargetRespondent>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/roster/study/{studyRef}',
            path: {
                'studyRef': studyRef,
            },
            query: {
                'contains': contains,
                'email': email,
                'name': name,
                'segment': segment,
                'slackSelected': slackSelected,
            },
        });
    }

    /**
     * Add a study_slack_target to a survey.
     * @returns any No response body
     * @throws ApiError
     */
    public static updateStudyRosterSlackTargets({
        slackUserRef,
        studyRef,
    }: {
        slackUserRef: string,
        studyRef: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/roster/study/{studyRef}/slack-targets/{slackUserRef}',
            path: {
                'slackUserRef': slackUserRef,
                'studyRef': studyRef,
            },
        });
    }

    /**
     * Remove a slack-targeted user from a survey.
     * @returns void
     * @throws ApiError
     */
    public static deleteStudyRosterSlackTargets({
        slackUserRef,
        studyRef,
    }: {
        slackUserRef: string,
        studyRef: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/roster/study/{studyRef}/slack-targets/{slackUserRef}',
            path: {
                'slackUserRef': slackUserRef,
                'studyRef': studyRef,
            },
        });
    }

    /**
     * Modify a targets for a survey.
     * @returns TargetRespondent
     * @throws ApiError
     */
    public static updateStudyTargets({
        studyRef,
        targetRef,
        requestBody,
    }: {
        studyRef: string,
        targetRef: string,
        requestBody?: PatchedTargetRespondentRequest,
    }): CancelablePromise<TargetRespondent> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/roster/study/{studyRef}/target/{targetRef}',
            path: {
                'studyRef': studyRef,
                'targetRef': targetRef,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Remove a targets from a survey.
     * @returns void
     * @throws ApiError
     */
    public static deleteStudyTargets({
        studyRef,
        targetRef,
    }: {
        studyRef: string,
        targetRef: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/roster/study/{studyRef}/target/{targetRef}',
            path: {
                'studyRef': studyRef,
                'targetRef': targetRef,
            },
        });
    }

    /**
     * Create a new team
     * @returns any No response body
     * @throws ApiError
     */
    public static createTeam({
        requestBody,
    }: {
        requestBody: CreatedTeamRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/roster/team',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Get a team's details.
     * @returns Team
     * @throws ApiError
     */
    public static getTeam({
        teamRef,
    }: {
        teamRef: string,
    }): CancelablePromise<Team> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/roster/team/{teamRef}',
            path: {
                'teamRef': teamRef,
            },
        });
    }

    /**
     * Update a team
     * @returns Team
     * @throws ApiError
     */
    public static updateTeam({
        teamRef,
        requestBody,
    }: {
        teamRef: string,
        requestBody?: PatchedTeamRequest,
    }): CancelablePromise<Team> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/roster/team/{teamRef}',
            path: {
                'teamRef': teamRef,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Delete a team
     * @returns void
     * @throws ApiError
     */
    public static deleteTeam({
        teamRef,
    }: {
        teamRef: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/roster/team/{teamRef}',
            path: {
                'teamRef': teamRef,
            },
        });
    }

    /**
     * Get all active teams.
     * @returns Team
     * @throws ApiError
     */
    public static getTeams(): CancelablePromise<Array<Team>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/roster/teams',
        });
    }

}
